/**
 * Navigate to a URL while preserving the current page's URL hash in browser history.
 *
 * Uses pushState + router.replace instead of navigateTo/router.push because
 * Vue Router's push() calls replaceState on the current entry before pushing,
 * which strips any hash fragment set externally (e.g. by urlHashHandler for filters/sort).
 *
 * By calling pushState first, the current URL (with hash) is saved in the
 * history stack. Then router.replace updates Vue Router's internal state
 * for the new entry without creating a duplicate history entry.
 */
export function navigateWithHash(url: string) {
    window.history.pushState(history.state, '', url)
    useRouter().replace(url)
}
